import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const BrazilIcon = ()=>/*#__PURE__*/ _jsxs("svg", {
        width: "22",
        height: "20",
        viewBox: "0 0 22 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M0 20C1 14 3 10 6 10C9 10 11 14 12 20H0Z",
                fill: "#009B3A"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10 20C11 12 13 4 16 2C17 1.5 18.5 2 19.5 4C21 8 22 14 22 20H10Z",
                fill: "#009B3A"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M6 10L16 2",
                stroke: "#009B3A",
                strokeWidth: "0.6"
            })
        ]
    });
